export default "__VITE_ASSET__117dbf47__"